// extracted by mini-css-extract-plugin
export default {"card-item":"i0BqLz","main":"DsAREX","title":"K5ogy7"};